import { navigateTo } from '#imports'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { hasCollectionPointAddressCompleted } from '../../utils/hasCollectionPointAddressCompleted'
import { hasCollectionPointOptionSelected } from '../../utils/hasCollectionPointOptionSelected'

export function useRedirectIfMissingCollectionPoint(currentStep: string) {
  const logger = useLogger()

  const redirectIfMissingCollectionPoint = async (
    items: ApiSpecs['/bm/cart']['GET']['response']['cartItems'],
    shippableCountries: ApiSpecs['/bm/cart']['GET']['response']['shippableCountries'],
    addressList: ApiSpecs['/bm/cart']['GET']['response']['addressList'],
    targetStep: string,
    lastCollectionPoint?: ApiSpecs['/bm/cart']['GET']['response']['lastCollectionPoint'],
  ) => {
    if (
      hasCollectionPointOptionSelected(items) &&
      !hasCollectionPointAddressCompleted(lastCollectionPoint)
    ) {
      logger.info(`[CHECKOUT][${currentStep}] No selected collection point`, {
        shippableCountries,
        shippingCountry: addressList.deliver?.country,
        owners: ['bot-squad-checkout-front'],
      })

      await navigateTo({ name: targetStep })
    }
  }

  return { redirectIfMissingCollectionPoint }
}
